<template>
    <div>
        <breadcrumb :items="breadcrumbs"></breadcrumb>
        <v-container fluid>
            <div class="d-flex mb-4">
                <h2>{{$t('Geofence')}}</h2>
                <v-spacer></v-spacer>
            </div>
            <v-card
                elevation="0"
                class="pa-0"
            >
                <v-card-text class="pa-0">
                     <v-row class="fill-height black--text" no-gutters>
                        <v-col cols="3" class="px-5 py-5">
                            <h2 class="mb-5">Select Map Type</h2>
                            <div @click="changeMapType('terrain')">
                                <v-img  src="/icons/terrian.png"></v-img>
                            </div>
                            <p class="mt-2 body-2">Terrain</p>
                            <v-img  @click="changeMapType('roadmap')" src="/icons/normal.png"></v-img>
                            <p class="mt-2 body-2">Normal</p>
                            <div @click="changeMapType('satellite')">
                                <v-img src="/icons/satelite.png"></v-img>
                            </div>
                            
                            <p class="mt-2 body-2">Satelite</p>
                        </v-col>
                        <v-col cols="9">
                            <!-- <GoogleMapLoader
                                :mapConfig="mapOptions"
                                apiKey="AIzaSyAmtVG0aR1UJXqayZeoVqoP-o39CBOOCB8"
                            /> -->
                            <div class="google-map" style="width:100%;height:520px" id="map" ref="googleMap"></div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>
<script>
// import GoogleMapLoader from "@/components/GoogleMapLoader.vue"
import { Loader } from '@googlemaps/js-api-loader';

export default {
    components: {
        // GoogleMapLoader
    },
    async mounted() {
        const success = (position) => {
            const latitude  = position.coords.latitude;
            const longitude = position.coords.longitude;
            this.mapOptions.center.lat = latitude;
            this.mapOptions.center.lng = longitude;
        };
        

        const error = (err) => {
            console.log(err)
        };

        // This will open permission popup
        navigator.geolocation.getCurrentPosition(success, error);
        try {
            const loader = await new Loader({
                apiKey: "AIzaSyAmtVG0aR1UJXqayZeoVqoP-o39CBOOCB8",
            }).load();
            this.google = loader;
            this.initializeMap();
        
        }catch(e) {
            console.log(e);
        }
    },
    data() {
        return {
            google: null,
            map: null,
            mapOptions: {
                center: {
                    lat: -34.397,
                    lng: 150.644
                },
                styles: {
                    overflow: 'visible'
                },
                zoom: 7
            },
            breadcrumbs: [
				{
					text: 'Dashboard',
					disabled: false,
					to: '/',
				},
				{
					text: 'Walk And Measure',
					disabled: true,
				},
			],
        }
    },
    methods: {
        async initializeMap() {
            const mapContainer = this.$refs.googleMap
            this.map = await new this.google.maps.Map(mapContainer, this.mapOptions);
        },

        changeMapType(type) {
            console.log(type);
            this.map.setMapTypeId(type);
        }

    }
}

</script>
